/**
 * Primitives das telas de auth (paleta cream/terracotta + tipografia
 * Geist/Instrument Serif/Geist Mono). Todas as primitives dependem do
 * `<AuthShell>` wrapper pra herdar os tokens corretos.
 *
 * Showcase em /admin/design-system#auth-primitives.
 * Origem visual: templates/Login com Google/.
 */
export { AuthShell } from './AuthShell';
export { AuthSurface } from './AuthSurface';
export { Logo7b } from './Logo7b';
export { Tag } from './Tag';
export { OrDivider } from './OrDivider';
export { SectionLabel } from './SectionLabel';
export { AgendaPreview } from './AgendaPreview';
export { TrialPreview } from './TrialPreview';
export { Testimonial } from './Testimonial';
export { StepDots } from './StepDots';
export { AuthSheet } from './AuthSheet';
